import { Platform } from 'react-native';
import { highChartsLib } from '../highChartsLib';

const rnMessager =
  Platform.OS === 'web'
    ? 'alert(message);'
    : 'window.ReactNativeWebView.postMessage(message);';

const js = `
    (() => {
      const sendDataToReactNativeApp = (message) => {
        try {
          ${rnMessager}
        } catch (error) {
          console.error('Error in sendDataToReactNativeApp:', error);
        }
      };
    
      const handleError = (error, context) => {
        console.error(\`Error in \${context}:\`, error);
        sendDataToReactNativeApp(JSON.stringify({ error: error.message, context }));
      };
    
      const renderChart = (config) => {
        try {
          document.getElementById("body").innerHTML = "";
          const div = document.createElement("div");
          div.id = 'hg-chart';
          div.style.height = '95vh';
          document.body.appendChild(div);
    
          Highcharts.setOptions({
            lang: {
              decimalPoint: ',',
              thousandsSep: '.',
              loading: 'Daten werden geladen...',
              months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
              weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
              shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
              exportButtonTitle: 'Exportieren',
              printButtonTitle: 'Drucken',
              rangeSelectorFrom: 'Von',
              rangeSelectorTo: 'Bis',
              rangeSelectorZoom: 'Zeitraum',
              printChart: 'Drucken',
              downloadPNG: 'Download als PNG-Bild',
              downloadJPEG: 'Download als JPEG-Bild',
              downloadPDF: 'Download als PDF-Dokument',
              downloadSVG: 'Download als SVG-Bild',
              resetZoom: 'Zoom zurücksetzen',
              resetZoomTitle: 'Zoom zurücksetzen',
              noData: 'keine Ergebnisse'
            }
          });
    
          Highcharts.chart(div.id, config);
        } catch (error) {
          handleError(error, 'renderChart');
        }
      };
    
      const onMessage = (message) => {
        try {
          const { data } = message;
          const { config } = JSON.parse(data);
          renderChart(config);
        } catch (error) {
          handleError(error, 'onMessage');
        }
      };
    
      document.addEventListener("DOMContentLoaded", () => {
        try {
          const eventEmitter = ${Platform.OS === 'android' ? 'document' : 'window'};
          eventEmitter.addEventListener("message", onMessage);
        } catch (error) {
          handleError(error, 'DOMContentLoaded');
        }
      });
    })();
`;

export const html = `
<!DOCTYPE html>
<html lang="en">
  <head>
  <meta charset="UTF-8" />
  <meta
    name="viewport"
    content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"
  />
  <meta http-equiv="Content-Security-Policy" content="
   default-src 'none';
   script-src 'self'
   'sha256-Qsc5AMVtFv4qA9VJFvqq6NHt3U/wIxJWazQiNuew6NY='
   'sha256-6/Vpf0STQHnnYPyUXv3uyzItIoykAuAW68TE34SoxeU='
   'sha256-GJjDN7YqK1SwyzxDavpmSRiHMGV6+B0RpAcyp8kwIH4='
   'sha256-axG9RjKeRZrc41msxixamwhy9tYreBDQ+yBloWrTK54='
   'sha256-m8Ou/OeedeH7dEiB+mBph70eOhAvB051EuPw4UrrNv4=';
   style-src 'self' 'unsafe-inline';
   img-src https://neolexon-stage-assets.obs-website.eu-de.otc.t-systems.com https://neolexon-assets.obs-website.eu-de.otc.t-systems.com data:;
   connect-src 'none';
  "/>        
  <meta http-equiv="X-UA-Compatible" content="ie=edge" />
    <title>Document</title>    
  </head>
<body id="body">
<script>
${highChartsLib}
</script>
<script>
  ${js}
</script>
</body>
</html>
`;
